
export enum DataCenter {
    Ssjzx = 0,
    Wjssjzx = 1,
    Yjgzyyfx = 2,
}

export const dataCenterCategories = [
    DataCenter.Ssjzx,
    DataCenter.Wjssjzx,
    DataCenter.Yjgzyyfx,
  
]

export function getdataCenterName(dataCenter: DataCenter): string {
    switch (dataCenter) {
        case DataCenter.Ssjzx:
            return "省数据分析";
        case DataCenter.Wjssjzx:
            return '卫健委(局)数据分析'
        case DataCenter.Yjgzyyfx:
            return "预警规则应用分析";
    }
}